import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs } from "../utils/index"
import TextSplitScrollTrigger from "../components/TextSplitScrollTrigger"
import { ScrollTrigger } from "../libraries/gsap"

export default class Quotes extends Component {
  constructor(obj) {
    super(obj)

    this.testimonies = qsa(".testimony", this.el)
    this.activeTestimony = 0

    this.testimonies.forEach((testimony, index) => {
      if (index !== 0) {
        // const dropdown = qs(".dropdown", testimony)
        // gsap.set(dropdown, {
        //   // height: "0",
        //   // onComplete: () => {
        //   //   this.renderer.smooth.update()
        //   //   ScrollTrigger.refresh()
        //   // },
        // })
      }
      testimony.addEventListener("click", e => this.onClick(e, index))
    })
    // this.splitText = qsa("[data-split]", this.el)
    // this.textSplitter = new TextSplitScrollTrigger({
    //   el: this.el,
    //   splitText: this.splitText,
    //   animate: this.animate.bind(this),
    // })
  }

  onClick = (e, index) => {
    // if the clicked one is the active one, do nothing
    if (index === this.activeTestimony) {
      return
    }

    const oldDropdown = this.testimonies[this.activeTestimony].querySelector(".dropdown")
    const oldStars = qs(".stars-desktop", this.testimonies[this.activeTestimony])
    const newDropdown = qs(".dropdown", e.target)
    const newStars = qs(".stars-desktop", e.target)

    // else open it

    gsap.to(oldStars, {
      autoAlpha: 0,
      duration: 1.2,
    })
    gsap.to(oldDropdown, {
      height: 0,
      autoAlpha: 0,
      duration: 1.2,
    })

    this.testimonies[this.activeTestimony].classList.add("testimony_hidden")
    this.testimonies[index].classList.remove("testimony_hidden")

    gsap.to(newDropdown, {
      height: "auto",
      autoAlpha: 1,
      duration: 1.2,
      onComplete: () => {
        this.renderer.smooth.update()
        ScrollTrigger.refresh()
      },
    })

    gsap.to(newStars, {
      autoAlpha: 1,
      duration: 1.2,
    })

    this.activeTestimony = index
  }

  animate() {
    // const titleTop = qsa(".title_top .line-0", this.el)
    // gsap.from(titleTop, {
    //   y: 100,
    //   duration: 1.2,
    //   scrollTrigger: {
    //     trigger: titleTop,
    //     start: "top bottom",
    //   },
    // })
  }
}
